import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../../../public/icons/excel/form/chart.svg'
import _imports_1 from '../../../../../public/icons/excel/form/list.svg'
import _imports_2 from '../../../../../public/icons/excel/arrow_left.svg'
import _imports_3 from '../../../../../public/icons/excel/save.svg'
import _imports_4 from '../../../../../public/icons/arrow_right.svg'
import _imports_5 from '../../../../../public/icons/excel/form/signout_64.png'
import _imports_6 from '../../../../../public/icons/excel/form/select_parameters_64.png'
import _imports_7 from '../../../../../public/icons/excel/form/audit_trail_64.png'
import _imports_8 from '../../../../../public/icons/excel/form/add_row_64.png'
import _imports_9 from '../../../../../public/icons/excel/form/view_log_64.png'
import _imports_10 from '../../../../../public/icons/excel/form/line_item_64.png'
import _imports_11 from '../../../../../public/icons/excel/form/parameter.svg'


const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_2 = {
  key: 0,
  class: "mt-2",
  style: {"flex-grow":"1"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "ml-1 text-white" }
const _hoisted_5 = ["onMouseover", "onMouseleave"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "ml-1 text-white" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "listItem ml-5 mt-1" }
const _hoisted_10 = { class: "ml-1 text-white" }
const _hoisted_11 = { class: "ml-1" }
const _hoisted_12 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","z-index":"1000","flex-grow":"1"}
}
const _hoisted_13 = { style: {"display":"flex","background-color":"var(--accent-color3)","height":"40px"} }
const _hoisted_14 = { style: {"text-align":"center","flex-grow":"1"} }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "textAreaCode d-flex" }
const _hoisted_17 = {
  key: 2,
  style: {"width":"100%","flex-grow":"1"},
  class: "itemGrid"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 3,
  class: "bottomBar"
}
const _hoisted_21 = { class: "iconsLeft" }
const _hoisted_22 = { class: "iconsRight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.processesAndDataViewsView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WorkbookControls, (wc, i) => {
            return (_openBlock(), _createBlock(_TransitionGroup, {
              name: "slide",
              tag: "span"
            }, {
              default: _withCtx(() => [
                (_ctx.dataViews && _ctx.isDataView(wc))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "listItem",
                      onClick: ($event: any) => (_ctx.Fluence.Run(wc))
                    }, [
                      _cache[18] || (_cache[18] = _createElementVNode("img", {
                        src: _imports_0,
                        class: "reverse-accent-svg"
                      }, null, -1)),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(wc.FullName), 1)
                    ], 8, _hoisted_3))
                  : _createCommentVNode("", true),
                (_ctx.processes && _ctx.isProcess(wc))
                  ? (_openBlock(), _createElementBlock("div", {
                      onMouseover: ($event: any) => (wc.Enabled = true),
                      onMouseleave: ($event: any) => (wc.Enabled = false),
                      key: i
                    }, [
                      _createElementVNode("div", {
                        class: "listItem",
                        onClick: ($event: any) => (_ctx.Fluence.Run(wc))
                      }, [
                        _createElementVNode("div", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("img", {
                            src: _imports_1,
                            class: "reverse-accent-svg"
                          }, null, -1)),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(wc.FullName), 1)
                        ])
                      ], 8, _hoisted_6),
                      _createVNode(_Transition, {
                        name: "expanded",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (wc.Enabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Fluence.processRuns, (pr, j) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (pr.FullName === wc.FullName)
                                      ? (_openBlock(), _createElementBlock("div", { key: j }, [
                                          _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(pr.Name), 1)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Fluence.processRunLog, (prl, k) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                              (prl.processRunId === pr.Id)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    class: "ml-5 mt-1",
                                                    key: prl.activityRunId+prl.time
                                                  }, [
                                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Fluence.getEnumKeyFromValue(prl.level)) + " - " + _toDisplayString(prl.message), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          }), 256))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ], 40, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]))
      : (_ctx.scriptView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "button",
                class: "scriptNavBtn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.scriptView = false; _ctx.settingsView = true;})
              }, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "reverse-accent-svg",
                  style: {"height":"100%"}
                }, null, -1)
              ]))]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "scriptNavBtn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.runScript()))
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", { style: {"margin-right":"5px","vertical-align":"text-top"} }, "Run Script", -1)),
                  _createElementVNode("img", {
                    src: _ctx.getIconPath('/icons/workflow/run.svg'),
                    class: "reverse-accent-svg"
                  }, null, 8, _hoisted_15)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "scriptNavBtn",
                style: {"padding":"5px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateCustomXml()))
              }, [...(_cache[22] || (_cache[22] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "reverse-accent-svg",
                  style: {"height":"100%"}
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"margin-top":"5px"} }, [
                _createElementVNode("span", { class: "blink_text" }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "reverse-accent-svg"
                  })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.textAreaCode) = $event)),
                class: "textAreaCode"
              }, null, 512), [
                [_vModelText, _ctx.textAreaCode]
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            (!_ctx.settingsView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "item" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      width: "52",
                      height: "52"
                    }),
                    _createElementVNode("div", null, "Internal Testing")
                  ], -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "item" }, [
                    _createElementVNode("img", {
                      src: _imports_6,
                      width: "52",
                      height: "52"
                    }),
                    _createElementVNode("div", null, "Open")
                  ], -1)),
                  (!_ctx.IsForm)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.processes = true; _ctx.processesAndDataViewsView = true; _ctx.settingsView = false})
                      }, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("img", {
                          src: _imports_7,
                          width: "52",
                          height: "52"
                        }, null, -1),
                        _createElementVNode("div", null, "Processes", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (!_ctx.IsForm)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.dataViews = true; _ctx.processesAndDataViewsView = true; _ctx.settingsView = false})
                      }, [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("img", {
                          src: _imports_8,
                          width: "52",
                          height: "52"
                        }, null, -1),
                        _createElementVNode("div", null, "Dataviews", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "item" }, [
                    _createElementVNode("img", {
                      src: _imports_9,
                      width: "52",
                      height: "52"
                    }),
                    _createElementVNode("div", null, "Show Logs")
                  ], -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.Fluence.AddProcessTemplate(_ctx.SelectedRangeAddress)))
                  }, [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("img", {
                      src: _imports_8,
                      width: "52",
                      height: "52"
                    }, null, -1),
                    _createElementVNode("div", null, "Process Template", -1)
                  ]))]),
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.Fluence.AddDataViewTemplate(_ctx.SelectedRangeAddress)))
                  }, [...(_cache[30] || (_cache[30] = [
                    _createElementVNode("img", {
                      src: _imports_8,
                      width: "52",
                      height: "52"
                    }, null, -1),
                    _createElementVNode("div", null, "DataView Template", -1)
                  ]))]),
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.scriptView = true; _ctx.processesAndDataViewsView = false; _ctx.settingsView = false;})
                  }, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("img", {
                      src: _imports_8,
                      width: "52",
                      height: "52"
                    }, null, -1),
                    _createElementVNode("div", null, "Script", -1)
                  ]))]),
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.Fluence.ScanWorkbook(true, _ctx.textAreaCode)))
                  }, [...(_cache[32] || (_cache[32] = [
                    _createElementVNode("img", {
                      src: _imports_9,
                      width: "52",
                      height: "52"
                    }, null, -1),
                    _createElementVNode("div", null, "Rescan Workbook", -1)
                  ]))]),
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.Fluence.OpenProcessEditor()))
                  }, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("img", {
                      src: _imports_10,
                      width: "52",
                      height: "52"
                    }, null, -1),
                    _createElementVNode("div", null, "Open Process Editor", -1)
                  ]))]),
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.Fluence.StartStopDebugServer()))
                  }, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("img", {
                      src: _imports_7,
                      width: "52",
                      height: "52"
                    }, null, -1),
                    _createElementVNode("div", null, "Start/Stop Server Debug", -1)
                  ]))])
                ]))
          ])),
    (!_ctx.IsForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.processes ? 'icon' : 'h-100'])
            }, [
              (!_ctx.processes)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_1,
                    class: "h-100",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.processes = true; _ctx.processesAndDataViewsView = true; _ctx.settingsView = false}),
                    title: "Processes"
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_1,
                    class: "h-100 reverse-accent-svg",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.processes = false; _ctx.processesAndDataViewsView = _ctx.dataViews}),
                    title: "Hide Processes"
                  }))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.dataViews ? 'icon' : 'h-100'])
            }, [
              (!_ctx.dataViews)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_0,
                    class: "h-100",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.dataViews = true; _ctx.processesAndDataViewsView = true; _ctx.settingsView = false}),
                    title: "DataViews"
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_0,
                    class: "h-100 reverse-accent-svg",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.dataViews = false; _ctx.processesAndDataViewsView = _ctx.processes}),
                    title: "Hide DataViews"
                  }))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.settingsView ? 'icon' : 'h-100'])
            }, [
              (!_ctx.settingsView)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_11,
                    class: "h-100",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.settingsView = true; _ctx.processesAndDataViewsView = false; _ctx.processes = false; _ctx.dataViews = false; _ctx.scriptView = false}),
                    title: "Settings"
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_11,
                    class: "h-100 reverse-accent-svg",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.settingsView = false;}),
                    title: "Close Settings"
                  }))
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}